export default "__VITE_ASSET__CXTl5Gv0__"